import React, { useEffect } from 'react';

function Modal({ children, onClose }) {
    // Close modal when clicking outside or pressing escape key
    useEffect(() => {
        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEscapeKey);
        window.addEventListener('click', handleBackgroundClick);

        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
            window.removeEventListener('click', handleBackgroundClick);
        };
    }, []);

    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            className="fixed inset-0 z-50 flex items-center justify-center bg-noir bg-opacity-90"
            onClick={handleBackgroundClick}
        >
            <div className="text-blanc rounded-md relative max-h-[90vh] overflow-y-auto">
                {children}
            </div>
        </div>
    );
}

export default Modal;